export default [
    {
        id: 1,
        name: "Dr.Rajini",
        coverImg: "",
        qualification: "MD Ortho",
        practice: "Gandhi Hospital",
       
    },
    {
            id: 2,
            name: "Dr.Shubhankar",
            coverImg: "",
            qualification: "MD Ortho",
            practice: "Gandhi Hospital",
           
        },
        {
            id: 3,
            name: "Dr.Bhavana",
            coverImg: "",
            qualification: "MD Ortho",
            practice: "Gandhi Hospital",
           
        },
]